<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<ng-container *ngIf= "box" >
    <div class="popup" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
        <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
            <h4 fxFlex="auto">  {{ locale.translations['ads']['comment']['n281'] }}</h4>
            <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
              <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-divider class="-mx-6 text-border"></mat-divider>
    <div class="reply_list">
 <div class="mdc-layout-grid__cell--span-12" *ngFor="let _repliesList of repliesListArr ; let i =  index">
    <ul class="details_wrap mdc-layout-grid__cell--span-12">
        <div *ngIf="_repliesList.status ==='1'" class="w-100 details_wrap" >
        <li class="px-4">
            <p >
                <strong>{{_repliesList.name}}</strong> <span  *ngIf="_repliesList.userID == data['userAd']" class="owner_btn mx-1"> {{ locale.translations['ads']['comment']['n283'] }}</span>
            </p>
            <p >
                {{ _repliesList.comment}}
            </p>

        </li>
        <li class="text-center pt-3" >
            <span class="time">{{_repliesList.createdAt}} {{ locale.translations['ads']['ad']['n303'] }} </span><br />

        <ng-container *ngIf="this.user">
            <span *ngIf="getToggle(_repliesList)">
                <button (click)="toggle(_repliesList.id,_repliesList.status)" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
                    <mat-icon *ngIf="_repliesList.status ==='1'">visibility_off</mat-icon>
                    <mat-icon *ngIf="_repliesList.status ==='2'">visibility_on</mat-icon>
                </button>
            </span>
        </ng-container>

        </li>
        </div>


        <div *ngIf="_repliesList.status ==='2'" class="gray_bg details_wrap" >
            <li class="px-4 ">
                <p >
                    <strong>{{_repliesList.name}}</strong> <span  *ngIf="_repliesList.userID == data['userAd']" class="owner_btn mx-1"> {{ locale.translations['ads']['comment']['n283'] }}</span>
                </p>
                <p >
                    {{ _repliesList.comment}}
                </p>

            </li>
            <li class="text-center pt-3" >
                <span class="time">{{_repliesList.createdAt}} {{ locale.translations['ads']['ad']['n303'] }} </span><br />

            <ng-container *ngIf="this.user">
                <span *ngIf="getToggle(_repliesList)">
                    <button (click)="toggle(_repliesList.id,_repliesList.status)" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
                        <mat-icon *ngIf="_repliesList.status ==='1'">visibility_off</mat-icon>
                        <mat-icon *ngIf="_repliesList.status ==='2'">visibility_on</mat-icon>
                    </button>
                </span>
            </ng-container>

            </li>
            </div>

    </ul>
 </div>
 <ng-container *ngIf="load">
    <span  (click)= "LoadMore()" class="load_btn">
        {{ locale.translations['ads']['ad']['n302'] }}  <span *ngIf="showLoad"><img [src] = "'/assets/images/loading.gif' | s3Image"></span>

    </span>
            </ng-container>
 </div>


 <div class="comment_footer" >
 <div class="mdc-layout-grid__cell--span-12" >
    <textarea  class="type_a_comment" [(ngModel)]="reply" placeholder=" {{ locale.translations['ads']['comment']['n284'] }}"></textarea>
    <button  *ngIf="locale.lang === 'en'" class="go_btn" mat-icon-button color="primary" [disabled]="!reply"
        (click)="addReply(reply,data.commentID)">
    <mat-icon > send </mat-icon>
    </button>
    <button   *ngIf="locale.lang === 'ku'" class="go_btn_rev" mat-icon-button color="primary" [disabled]="!reply"
    (click)="addReply(reply,data.commentID)">
<mat-icon > send </mat-icon>
</button>
<button  *ngIf="locale.lang === 'ar'" class="go_btn_rev" mat-icon-button color="primary" [disabled]="!reply"
(click)="addReply(reply,data.commentID)">
<mat-icon > send </mat-icon>
</button>
        </div>
 </div>
    </div>
</ng-container>
